import { chapters } from '../story/chapters';

export function StoryOverlay({ progress }: { progress: number }) {
  return (
    <div className="story-overlay" aria-live="polite">
      {chapters.map((chapter) => {
        const midpoint = (chapter.start + chapter.end) / 2;
        const radius = (chapter.end - chapter.start) / 2;
        const distance = Math.abs(progress - midpoint);
        const opacity = Math.max(0, 1 - distance / Math.max(radius, 0.001));
        return (
          <section
            key={chapter.id}
            className={`chapter chapter--${chapter.align ?? 'left'}`}
            style={{ opacity, pointerEvents: opacity > 0.6 ? 'auto' : 'none' }}
          >
            {chapter.eyebrow && <p className="chapter__eyebrow">{chapter.eyebrow}</p>}
            <h1>{chapter.title.split('\n').map((line) => <span key={line}>{line}</span>)}</h1>
            {chapter.body && <p className="chapter__body">{chapter.body}</p>}
            {chapter.id === 'finale' && <button type="button">CHOOSE YOUR DIRECTION</button>}
          </section>
        );
      })}
    </div>
  );
}
